import { AxiosRequestConfig, AxiosResponse } from 'axios';
import querystring from 'querystring';
import config from 'config';

import { parseQrCode } from 'models/qrCode';
import { HttpClient, QueryOptions, QrCodeData } from './api-types';

const API_KEY = config.api.apiKey;
const API_URL = config.api.apiUrl;
const API_PATH = config.api.apiPath;

const QR_CODE_VERSION = 'v1';

export const queryApi = (
  httpClient: HttpClient,
  url: string,
  options?: QueryOptions,
): Promise<AxiosResponse> => {
  const request: AxiosRequestConfig = {
    url,
    method: options && options.data ? 'post' : 'get',
    headers: { 'x-api-key': API_KEY },
  };

  if (options) {
    if (options.params) request.params = options.params;
    request.headers = {
      ...request.headers,
      ...options.headers,
    };
    if (options.data) {
      if (options.contentType === 'JSON') {
        request.data = JSON.stringify(options.data);
        request.headers = {
          ...request.headers,
          'content-type': 'application/json',
        };
      } else {
        request.data = querystring.stringify(
          options.data as querystring.ParsedUrlQueryInput,
        );
        request.headers = {
          ...request.headers,
          'content-type': 'application/x-www-form-urlencoded',
        };
      }
    }
  }

  return httpClient(request);
};

const getApiUrl = (target: string, version: string, suffix = ''): string => {
  return `${API_URL}${API_PATH}/${target}/${version}/${suffix}`;
};

export const fetchQrCodeUrl = async (
  httpClient: HttpClient,
  data: QrCodeData,
): Promise<string> => {
  const updatedData = {
    ...data,
    devicetype: config.ksDeviceType,
    qrversion: 15,
  };

  const response = await queryApi(
    httpClient,
    getApiUrl('qrcode', QR_CODE_VERSION),
    {
      data: updatedData,
      contentType: 'JSON',
    },
  );

  return parseQrCode(response);
};
